import map from 'lodash/map'
import React from 'react'
import { Select } from '@ztechapps/webui.input'
import { UsTimeZone } from '@ztechapps/common.contract'

export const UsTimeZoneOptions = map(UsTimeZone, (item) => {
  return {
    value: item,
    label: item,
  }
})

export const UsTimeZoneSelect = ({ ...rest }) => {
  return (
    <Select
      {...{
        ...rest,
        options: UsTimeZoneOptions,
      }}
    />
  )
}
